import Base from "@/controllers/base";
export default class Company extends Base {
  constructor(elem) {
    super(elem);
  }

  printName(event) {
    const input = event.target;
    const form = event.target.closest("form");
    const toInput = form.querySelector("input#company_print_name");
    input.dataset.value = input.value;
    if (toInput != null) toInput.value = input.value;
  }

  creditLimit(event) {
    const input = event.target;
    const id = "company_credit_hold";
    const target = document.getElementById(id);
    if (target) target.disabled = !!input.value;
  }

  attachJ1s(event) {
    const select = event.target;
    const section = document.getElementById("j1s-types");
    const checkboxs = section.querySelectorAll("input[type=checkbox");
    const customized = select.value == "Customized";
    section.style.display = customized ? "block" : "none";
    checkboxs.forEach((cb) => (cb.disabled = !customized));
  }

  muteEmail(event) {
    const input = event.target;
    const id = "company_email_settings_mute_appt_confirmed";
    const target = document.getElementById(id);
    if (target) target.disabled = input.checked;
  }

  driverTypeChanged(event) {
    event.target
      .closest("form")
      .querySelectorAll(".company-driver")
      .forEach((input) => {
        input.disabled = event.target.value != "company_driver";
      });
  }

  chooseOrderSubjectPrefix(event) {
    const orderSubjectPrefix = event.target
      .closest("form")
      .querySelector("input#company_email_settings_order_subject_prefix");
    const textContent = event.target.textContent;
    if (orderSubjectPrefix.value.includes(textContent)) {
      orderSubjectPrefix.value = orderSubjectPrefix.value
        .replace(textContent, "")
        .trim();
    } else {
      orderSubjectPrefix.value = [orderSubjectPrefix.value, textContent]
        .join(" ")
        .trim();
    }
  }

  static initJ1sDocs() {
    setTimeout(() => {
      const id = "company_invoice_settings_j1s_scope";
      const section = document.getElementById(id);
      if (section) section.dispatchEvent(new Event("change"));
    }, 250);
  }
}

document.addEventListener("turbo:load", () => {
  Company.initJ1sDocs();
});
